import { Typography } from '@mui/material';
import { Modal } from '../../../../components/Modal/Modal';
import styles from './styles.module.css';
import { Spinner } from '../../../../components/Spinner/Spinner';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { useEditServiceInfoPricesModal } from './useEditServiceInfoPricesModal';
import { Row } from './components';
import { UpdatePriceDto } from './types';

interface EditServiceInfoModalProps {
  open: boolean;
  onClose: () => void;
  selectedServiceInfoId: string;
}

const TABLE_HEADERS = ['Model', 'Old price', 'Price'] as const;

export const EditServiceInfoPricesModal = ({ onClose, open, selectedServiceInfoId}: EditServiceInfoModalProps) => {
  const {
    hasData,
    data,
    loading,
    onSave
  } = useEditServiceInfoPricesModal({selectedServiceInfoId})

  const renderContent = () => {
    if (loading) {
      return <Spinner />;
    }

    if (!hasData) {
      return <Typography>No services.</Typography>;
    }

    return (
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table sx={{ minWidth: 650 }} aria-label="update prices table">
          <TableHead>
            <TableRow>
              {TABLE_HEADERS.map((item) => (
                <TableCell className={styles.text} key={item}>
                  {item}
                </TableCell>
              ))}
              <TableCell className={styles.text} align="right">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data!.map((item: UpdatePriceDto) => (
              <Row key={item.serviceId} item={item} onSave={(data) => onSave(item.serviceId, data)} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Modal
      title={
        <div className={styles.modalHeader}>
          <Typography variant="h6">Update prices</Typography>
        </div>
      }
      open={open}
      onClose={onClose}
    >
      {renderContent()}
    </Modal>
  );
};
